import React, { Component } from "react";
import whitewater from "../images/whitewaterBackground.jpg";
import background3 from "../images/background3.jpg";

class About extends Component {
  componentDidMount() {
    // Initialize Materialize parallax after component mounts
    if (window.$ && window.$(".parallax").parallax) {
      window.$(".parallax").parallax();
    }
  }

  render() {
    return (
      <div>
        <div className="parallax-container valign-wrapper">
          <div className="section no-pad-bot">
            <div className="container">
              {/* <div className="row center">
                <h5 className="header col s12 teal-text" />
              </div> */}
            </div>
          </div>
          <div className="parallax">
            <img src={whitewater} alt="Unsplashed background img 2" />
          </div>
        </div>

        <div className="container">
          <a name="about" />
          <div className="section">
            <div className="row">
              <div className="col s12 center">
                <h3>
                  <i className="mdi-content-send brown-text" />
                </h3>
                <h4>Mission</h4>
                <p className="left-align light">
                  At Moana Support we strive to live with the conscious decision
                  to be morally courageous, to be selfless, in our actions, to
                  inspire the lives of individuals, families, employees and the
                  community we serve. We believe in reciprocity, that the energy
                  we give will be returned. At Moana Support we are soft-spoken,
                  responsible leaders of integrity, who are mindful and
                  empathetic. We act with the highest principle. We strive to
                  empower, develop, and uplift our employees so that they carry
                  out the good in themselves to care for the individuals we
                  support.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="parallax-container valign-wrapper">
          <div className="section no-pad-bot">
            <div className="container" />
          </div>
          <div className="parallax">
            <img src={background3} alt="Unsplashed background img 3" />
          </div>
        </div>
      </div>
    );
  }
}

export default About;
